import { Middleware, Context } from '@nuxt/types';
import { saveQueue } from '../lib/utilities/saveQueue';
import { SaveMessageState } from '../lib/enums/saveMessage';

const initialiseCampaign: Middleware = (context: Context) => {
  const store = context.store;

  saveQueue.pending = () => {
    store.commit(
      'components/campaign-navigation/setSaveMessageState',
      {
        saveMessageState: SaveMessageState.Pending
      },
      { root: true }
    );
  };
  saveQueue.complete = () => {
    store.commit(
      'components/campaign-navigation/setSaveMessageState',
      {
        saveMessageState: SaveMessageState.Saved
      },
      { root: true }
    );
  };
  return store.dispatch('campaign/initialiseCampaign', {
    id: context.params.id
  });
};

export default initialiseCampaign;
